import { render, staticRenderFns } from "./GBPhotoAlbumMng.vue?vue&type=template&id=9d3691c4&"
import script from "./GBPhotoAlbumMng.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumMng.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumMng.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports